import React from 'react'
import { observer, inject } from 'mobx-react'
import LoadingComponent from '../../../LoadingComponent'
import { Link } from 'react-router'
import { append } from '../../../../utils/url'
import { formatDate, formatSearchFilters } from '../../../../utils/format'
import Icon from '../../../util/Icon'
import DropdownMenu from '../../../navigation/DropdownMenu'
import OrderableTH from '../../../navigation/OrderableTH'
import StorePagination from '../../../navigation/StorePagination'
import classnames from 'classnames'

@inject('websites', 'recommended_searches')
@observer
export default class RecommendedSearches extends LoadingComponent {
  website = this.props.websites.current

  state = {
    search: '',
    order_by: 'created_at',
    order_dir: 'desc'
  }

  filtered_recommendation_status = {
    'pending':  'Pending',
    'accepted': 'Active',
    'declined': 'Unsubscribed'
  }

  hasLoaded() {
    return this.props.recommended_searches.loaded
  }

  loadPage(nextPage) {
    const { page=1 } = this.props.location.query
    this.props.recommended_searches.loadPage(nextPage || page, this.state)
  }

  handleSearch = ({ target: { value:search } }) => {
    this.setState({ search }, () => this.loadPage())
  }

  componentWillMount() {
    const { search='', order_by='created_at', order_dir='desc' } = this.props.location.query

    this.setState({ search, order_by, order_dir }, () => this.loadPage())
  }

  componentWillReceiveProps(nextProps) {
    const { page:next, ...nextQuery } = nextProps.location.query
    const { page:prev, ...prevQuery } = this.props.location.query

    if (next !== prev) {
      this.loadPage(next)
    } else if (nextQuery.order_by !== prevQuery.order_by || nextQuery.order_dir !== prevQuery.order_dir) {
      this.setState(nextQuery, () => this.loadPage())
    }
  }

  deleteHandlerFor = recommendedSearch => event => {
    event.preventDefault()
    const confirmed = window.confirm(`Really delete this search recommendation?`)
    if (!confirmed) {
      return
    }
    this.props.recommended_searches.delete(recommendedSearch.id)
  }

  renderLoaded() {
    const { state:{ highlight, search }={} } = this.props.location
    return (
      <div className="container padded recommended-searches">
        <div className="panel full padded">
          <h2 className="title">Recommended Search Subscriptions</h2>
          <div className="table-actions">
            <input type="search" placeholder="Search..." title="Find by lead name or search title" value={search} onInput={this.handleSearch} ref={(el) => { this.searchField = el }} />

            <Link className="button" to={append('add')}>New Search Recommendation</Link>
          </div>
          <div>
            <table className="zebra">
              <thead>
                <tr>
                  <th>Recommended To</th>
                  <OrderableTH query={this.state} field="searches.title">Search Name</OrderableTH>
                  <th>Filters</th>
                  <th>Recommended By</th>
                  <th>Frequency</th>
                  <th>Status</th>
                  <OrderableTH query={this.state} field="created_at">Created</OrderableTH>
                  <OrderableTH query={this.state} field="last_sent_at">Last Sent</OrderableTH>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody className="padded">
                {this.props.recommended_searches.map(rs => (
                  <tr key={rs.id} className={classnames({ highlight: highlight === rs.id })}>
                    <td>{rs.lead_name}</td>
                    <td className="center">{rs.search_title}</td>
                    <td className="muted">{formatSearchFilters(rs.search_params)}</td>
                    <td className="center">{rs.user_name}</td>
                    <td className="center">{rs.email_frequency}</td>
                    <td className="center">{this.filtered_recommendation_status[rs.recommendation_status]}</td>
                    <td className="center">{formatDate(rs.created_at)}</td>
                    <td className="center">{formatDate(rs.last_sent_at)}</td>
                    <td className="center">
                      <DropdownMenu menuClass="website-page-actions" menuTitle={<Icon icon="bars" />}>
                        <a href={`${this.website.default_url}search/${rs.saved_search_id}`} target="_blank">Preview Search</a>
                        <a className="danger" href="#" onClick={this.deleteHandlerFor(rs)}>Delete</a>
                      </DropdownMenu>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <StorePagination store={this.props.recommended_searches} query={this.state} />
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/website/RecommendedSearches/index.js